import type { Mouvement } from '@mairistem/comptabilite';
import type React from 'react';
import MandatAnnulantTitreAnterieurComponent from '../../../../components/Mouvement/Panel/InformationsRattachement/MandatAnnulantTitreAnterieurComponent';
import type PanelComponentProps from '../../../../interfaces/pieces/mouvements/panelComponentProps';
import InformationsRattachementPanel from '../InformationsRattachementPanel';

class MandatAnnulantTitreAnterieurPanel extends InformationsRattachementPanel {
	// Le bloc saisit l'exercice, la pièce d'origine et la ligne d'origine.
	isComplete = (data: Mouvement) =>
		this.isCompleteFor(
			data,
			'exerRattachement',
			'pieceOrigine',
			'idLigneOriginePes',
		);

	getComponent = function getComponent(
		data: PanelComponentProps['data'],
		onChange: PanelComponentProps['onChange'],
		handlePin: PanelComponentProps['handlePin'],
	): React.ReactElement {
		return (
			<MandatAnnulantTitreAnterieurComponent
				data={data}
				handlePin={handlePin}
				onChange={onChange}
				panel={this}
			/>
		);
	};
}

export default MandatAnnulantTitreAnterieurPanel;
